import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ProviderName } from '../../../account/models/login-response.model';
import { ApiService } from '../../../shared/services/core/api.service';
import { AuthService } from '../../../user/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class SeatGeekAuthService {
  /**
   * This holds all the SeatGeek settings required for sso,
   * this information will be read from the config js file
   * and also passed or defaulted from the login process.
   */
  constructor(
    private authService: AuthService,
    private api: ApiService) { }

  /**
   * Attempt to login using SeatGeek using redirect process.
   * This will call an endpoint to generate the login URL,
   * depending on the parameters passed.
   * @param clubId clubId to be passed to endpoint, default to 1.
   */
  login(
    clubId: number = 1
  ) {
    return this.api.post(`sso/OAuth/GenerateUrl/${ProviderName.SeatGeek}/${clubId}`, []).pipe(
      tap((generatedUrl: any) => {
        window.location.href = generatedUrl;
      })
    );
  }

  /**
   * This method is used to authenticate a token
   * that comes back from the SeatGeek login page
   * and log the user in via the tokens returned
   * from the response.
   * @param code code returned from SeatGeek, to be authenticated and passed to given endpoint.
   * @param clubId clubId to be passed to endpoint, default to 1.
   * @returns boolean from status of response.
   */
  validateCode(code: string, clubId: number = 1) {
    if (this.authService.hasAccessToken()) {
      return of(true);
    }

    return this.api.post(`sso/OAuth/${ProviderName.SeatGeek}/${code}/${clubId}`, `"${code}"`).pipe(
      tap((authResponse: any) => {
        if (authResponse) {
          this.authService.loginUsingToken(authResponse.tokens.AccessToken, authResponse.tokens.RefreshToken, '/');
        }
      }),
      map((authResponse: any) => {
        if ((authResponse.status = 200)) {
          return true;
        } else {
          return false;
        }
      })
    );
  }
}